const getters = {
    theme: state => state.app.theme,
    sysinfo: state => state.app.sysinfo,
    itemlist: state => state.app.itemlist,
    isTab1: state => state.app.isTab1,
    message_text: state => state.app.message_text,
    message_bac: state => state.app.message_bac,
    isShowMessage: state => state.app.isShowMessage,
}
export default getters
  